var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetsProhibited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 21 1)",
    stroke: "currentColor",
    strokeWidth: 1.3,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.063 17.255l2.838-7.252M11.875 15.626v3.561M8.735 5.24a2.494 2.494 0 011.89-.865v2.5l4.31 2.154c.423.212.69.645.69 1.119v.477c0 .442-.116.876-.34 1.258M3.371 3.371l13.258 13.258M11.875 16.25l-6.04-3.523"
  }))));
}
export default SvgPetsProhibited;